import {axiosRequest} from "./apiBase";
import Quiz from "../common/models/quiz/quiz.model";

export const getQuizById = (id: number) : Promise<Quiz> => {
    return axiosRequest(
        'GET',
        `quiz/${id}`
    );
}